import 'intersection-observer'
import * as React from "react"
import { InView } from 'react-intersection-observer'
import { IOWidget, Updater, fromJSX } from "widgets-for-react"
import { ImageSize, Link } from "../../../../cms/blocks/types.gen"
import { getClassName } from "../../../../cms/blocks/utils.gen"
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types"
import { CMSState } from '../../../drupalPage/state'
import { FeaturedContentBlock } from "./featuredContent"

export type ButtonProps = (
  | { kind: "button"; on_click: () => Updater<CMSState> }
  | Link ) & { title: string }

export type textImageBlockProps = {
  blockIndex: number
  imageLocation: "left" | "right"
  field_image?: ParsedMediaImage
  image?: number
  image_alt?: string
  label?: string
  title: string
  introduction?: string
  text: string
  primary_button?: Link
  secondary_button?: ButtonProps
  backgroundImage: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
  get_default_data_src:(() => ImageSize)
  get_default_data_srcset:(() => [ImageSize, string][])
}

export type textImageBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_wrapper_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function textImageBlock(
  props: textImageBlockProps,
  options?: { style?: textImageBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) => 
    fromJSX(
      setState => {
        return (
          <>
          <InView
            as="section"
            onChange={(inView) => blockInviewHandler('featuredContent', inView, `io-${options && options.key ? options.key : props.blockIndex}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.blockIndex}`}
            className=""
            key={options && options.key ? options.key : `block-${props.blockIndex}`}
          >

            <FeaturedContentBlock
              isStyleguide={false}
              alignImage={props.imageLocation}
              backgroundImage={props.backgroundImage}
              label={props.label}
              title={props.title}
              intro={props.introduction}
              field_image={props.field_image}
              primaryButton={props.primary_button}
              // The Drupal path only ever builds link-kind buttons (field_links),
              // the button kind exists for the CMS editor widget
              secondaryButton={props.secondary_button?.kind === 'link' ? props.secondary_button : undefined}
              image={props.image}
              image_alt={props.image_alt}
            />

          </InView>
        </>
        )
      },
    )
}
